export default __webpack_public_path__ + "static/media/carR.69331477.png";